import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import FAQSearch from '../../../Custom/FAQ/FAQSearch';
import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  margin: 40px auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 60px auto 70px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 90px auto 100px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h1``;

export const StyledFAQSearch = styled(FAQSearch)`
  margin-top: 30px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 45px;
  }
`;
